<template>
    <div class="admin_header">
        <div class="admin_img">
            <img src="../assets/wiccoLogo2.png" alt="Logo" style=" width: 70px">
        </div>
        <div class="admin_panel">
            <div>
                Admin Panel
            </div>
            </br>
            <div class="admin_nav">
                <router-link to="/">
                    <i class="material-icons" style="font-size:25px">home</i>
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'AdminHeader'
}
</script>

<style>
.admin_header {
    display: flex;
    background-color: #969696;
    color: #143D60;
    font-weight: bold;
    justify-content: space-between;
}

.admin_img {
    text-align: left;
    padding: 5px 0px 5px 15px;
}

.admin_panel {
    display: flex;
    align-items: center;
}

.admin_nav a {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    color: #143D60;
    text-decoration: none;
}
.admin_nav a:hover {
  color: rgba(237, 87, 62, 1);
}

.admin_nav .active {
  color: rgba(237, 87, 62, 1);
}
</style>